module.exports = __webpack_public_path__ + "img/icon_radius2.17346507.png";